const MAX_DEPTH = 5;

const BodyFieldNode = ({ field, depth = 0, isLast = false }) => {
	if (depth > MAX_DEPTH) return <div className="text-gray-500 text-xs pl-4">...</div>;

	const hasChildren = field.children && field.children.length > 0;
	const prefix = depth > 0 ? (isLast ? "\u2514\u2500 " : "\u251C\u2500 ") : "";

	return (
		<div>
			<div className="flex items-center py-0.5 text-xs" style={{ paddingLeft: depth * 16 }}>
				<span className="text-gray-500 font-mono whitespace-pre">{prefix}</span>
				<span className="font-mono text-gray-200">{field.name}</span>
				<span className="text-gray-500 ml-2">{field.type}</span>
				{field.required ? (
					<span className="text-red-400 text-[10px] ml-2">required</span>
				) : (
					<span className="text-gray-600 text-[10px] ml-2">optional</span>
				)}
			</div>
			{hasChildren &&
				field.children.map((child, i) => (
					<BodyFieldNode key={i} field={child} depth={depth + 1} isLast={i === field.children.length - 1} />
				))}
		</div>
	);
};

const BodyFieldTree = ({ fields = [], label = "Body" }) => {
	if (fields.length === 0) return null;

	return (
		<div className="mt-2">
			<div className="text-[10px] uppercase text-gray-500 font-semibold mb-1">{label}</div>
			<div className="border border-border/30 rounded p-2 bg-accent/20">
				{fields.map((field, i) => (
					<BodyFieldNode key={i} field={field} isLast={i === fields.length - 1} />
				))}
			</div>
		</div>
	);
};

export default BodyFieldTree;
